<template>
    <main>

        <h1 class="title is-4 mb-1">{{ title }}</h1>

        <section class="box">
            <div class="field is-horizontal mb-2"
                 v-for="(file, index) in files"
            >
                <div class="field-label">
                    <label class="label">{{ title }} {{ index + 1}}</label>
                </div>
                <div class="field-body">
                    <div class="field" v-if="file.id === null">
                        <div class="field is-grouped mb-1">
                            <div class="control is-expanded">
                                <input type="text"
                                       class="input"
                                       placeholder="ชื่อเอกสาร"
                                       :name="'files[' + type + '][' + index + '][title]'"
                                />
                                <input type="hidden"
                                       :name="'files[' + type + '][' + index + '][type]'"
                                       :value="type"
                                />
                            </div>
                            <a class="control tooltip" data-tooltip="ลบไฟล์" @click.prevent="deleteFile(index)">
                                <span class="delete"></span>
                            </a>
                        </div>
                        <div class="field is-half-desktop">
                            <input type="file"
                                   :name="'files[' + type + '][' + index + '][file]'"
                                   required
                            />
                        </div>
                    </div>
                    <div class="field" v-else>
                        <div class="field is-grouped is-half-desktop">
                            <div class="control is-expanded">
                                <a :href="file.route">
                                    {{ file.title }}
                                </a>
                            </div>
                            <a class="control" data-tooltip="ลบไฟล์" @click.prevent="destroyFile(file, index)">
                                <span class="delete"></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label">
                    <label class="label"></label>
                </div>
                <div class="field-body">
                    <button type="button" class="button is-300"
                            @click.prevent="addFile"
                    >เพิ่ม{{ title }}
                    </button>
                </div>
            </div>

        </section>
    </main>
</template>
<script type="text/babel">

    export default {
        props: {
            files: {type: Array, required: true},
            type: {type: String, required: true},
            title: {type: String, required: true},
        },

        methods: {
            addFile() {
                this.files.push({
                    id: null,
                    title: null,
                    type: this.type
                })
            },

            deleteFile(index) {
                this.$delete(this.files, index);
            },
            destroyFile(file, index) {
                axios.delete('projects-files/' + file.id)
                    .then(() => {
                        this.files.splice(index, 1);
                        flash('success', 'ลบไฟล์เรียบร้อย');
                    });
            },
        }
    }
</script>